module.exports = __webpack_public_path__ + "static/media/Montana2923.230ac420.jpg";